import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { followAuthorActions, followAuthorSelectors } from '@lialo/core/lib/pages/followAuthor';

export function useFollowState(authorId: string, authorName: string) {
  const dispatch = useDispatch();

  const followeeIds = useSelector(followAuthorSelectors.selectFolloweeIds);
  const isFollowing = followeeIds.includes(authorId);

  const onClick = () => {
    const author = { id: authorId, name: authorName };
    isFollowing
      ? dispatch(followAuthorActions.unfollowAuthor.request(author))
      : dispatch(followAuthorActions.followAuthor.request(author));
  };

  React.useEffect(() => {
    dispatch(followAuthorActions.fetchFolloweeIds.request({ force: false }));
  }, [dispatch]);

  return { isFollowing, onClick } as const;
}
